import { Icon } from "@chakra-ui/react";
import { TIconComponent } from "./icon-component.types";

export const IconFatArrowRight: TIconComponent = props => (
    <Icon viewBox="0 0 24 24" {...props}>
        <g fill="none" fillRule="evenodd">
            <path
                d="M12.3793 23.5735L23.5506 13.0768C24.1498 12.488 24.1498 11.5128 23.5506 10.924L12.3793 0.4265C11.4409 -0.496691 9.86808 0.177702 9.86808 1.50329V6.12484H0V17.7143H9.86808V22.4975C9.86808 23.8223 11.4409 24.4967 12.3793 23.5735Z"
                fill="currentColor"
            />
        </g>
    </Icon>
);
